import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const topCategories = categories.slice(0, 7);
  const bottomCategories = categories.slice(7);

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Categories
            </h4>
            <div className="space-y-2.5">
              {topCategories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              &nbsp;
            </h4>
            <div className="space-y-2.5">
              {bottomCategories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Top Brands
            </h4>
            <div className="space-y-2.5">
              {['Nike Spreadsheet', 'Adidas Spreadsheet', 'Jordan Spreadsheet', 'Yeezy Spreadsheet', 'Stussy Spreadsheet', 'Supreme Spreadsheet', 'Arc\'teryx Spreadsheet'].map((brand) => (
                <a
                  key={brand}
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer"
                >
                  {brand}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Resources
            </h4>
            <div className="space-y-2.5">
              <Link to="/guide/superbuy-spreadsheet-101" className="block text-sm text-foreground-600 hover:text-accent-600 transition-colors">
                Beginner&apos;s Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">
                Superbuy Sheet
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">
                Buy It Now
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">
                Latest Finds
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="w-7 h-7 rounded-md bg-accent-500 flex items-center justify-center">
              <i className="ri-database-2-line text-background-50 text-sm"></i>
            </span>
            <span className="font-heading font-bold text-foreground-900">
              Superbuy<span className="text-accent-600">Spreadsheet</span>
            </span>
          </div>

          <div>
            <p className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} SuperbuySpread.space — Curated Finds &amp; Buying Guides
            </p>
          </div>

          <div className="flex items-center gap-3">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-500 hover:text-accent-600 hover:bg-accent-50 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-500 hover:text-accent-600 hover:bg-accent-50 transition-colors cursor-pointer">
              <i className="ri-reddit-line"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-500 hover:text-accent-600 hover:bg-accent-50 transition-colors cursor-pointer">
              <i className="ri-discord-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}